import axios from "axios";
import { ShowToast, toastType } from "./toast-service";
import { API_HEADERS } from "../constants/api";
import commonLabels from "../constants/messageConstants";
import store from "../store/appStore";
import * as actionType from "../store/layout/actionTypes";
import * as loaderActionType from "../store/loader/actionTypes";
import { SPSToken } from "../constants/constants";
import * as LocalCacheActionType from "../store/localCache/actionTypes";
import _ from "lodash";

const localStore = [];
let currentlyExecuting = [];

/**
 * get Headers from token
 * @returns - header values
 */
export function getHeaders() {
	return {
		authorization: `${API_HEADERS.authName} ${localStorage.getItem(
			API_HEADERS.authToken
		)}`,
		cloudOrgId: localStorage.getItem(API_HEADERS.CID),
		CID: localStorage.getItem(API_HEADERS.CID),
		EMAIL: "dc.administrator@stream-dc.com",
		AGI: localStorage.getItem(API_HEADERS.AGI),
		"Cache-Control": "no-cache",
		IsExternal: localStorage.getItem("isExternal") || true
	};
}

/**
 * send request
 */
axios.interceptors.request.use(
	config => {
		store.dispatch({
			type: actionType.CLEAR_ERROR_PAGE,
			payload: null
		});
		if (config.headers.async == undefined) {
			store.dispatch({
				type: loaderActionType.SET_VISIBILITY,
				payload: true
			});
		}
		// console.log("Request was sent", config);
		return config;
	},
	error => {
		// console.log("Request was sent", error);
		return Promise.reject(error.response);
	}
);

/**
 * receive response
 */
axios.interceptors.response.use(
	response => {
		store.dispatch({
			type: loaderActionType.SET_VISIBILITY,
			payload: false
		});
		//console.log("response received", response);

		return response;
	},
	error => {
		store.dispatch({
			type: loaderActionType.SET_VISIBILITY,
			payload: false
		});
		//console.log("response received", error);
		if (error.message == "Network Error") {
			store.dispatch({
				type: actionType.SET_ERROR_PAGE,
				payload: commonLabels.serverError
			});
		}

		if (error.response) {
			localStorage.setItem("isApiCalled","false");
			if (error.response.status === 401) {
				localStorage.removeItem("adal.idtoken");
				localStorage.removeItem("selectedPropertyIdMultiple");
				localStorage.removeItem("selectedPropertyId");
				localStorage.removeItem("selectedPropertyIdMultipleNames");
				localStorage.removeItem("Abbreviation");
				localStorage.removeItem("selectedstartDate");
				localStorage.removeItem("selectedendDate");
				console.log("Un authenticated user")
				if (localStorage.getItem("isReloadAttempt")== undefined) {
					window.location = "/dc-user";
					console.log("Reload");
					localStorage.setItem("isReloadAttempt",true)
					window.location.reload();
				}
			} else if (error.response.status == 403) {
				if (
					error.response.data.isValidUser == false ||
					error.response.data.hasAccessToSection == false
				) {
					localStorage.setItem("isUnAuthorized", true);

					//window.location = routes.unAuthorizedAccess;
					store.dispatch({
						type: actionType.SET_ERROR_PAGE,
						payload: commonLabels.unAuthorizedAccess
					});
					//return Promise.reject(error.response);
				} else {
					error.response.data.message =
						error.response.data.message +
						" You don't have permission to access this resource/ perform an action. Please contact site administrator or Helpdesk team.";
				}
			} else if (error.response.status == 400) {
				const error1 = error.response.data.title
					? error.response.data.title
					: "";
				const error2 = error.response.data.message
					? error.response.data.message
					: "";
				error.response.data = {
					message: error1 || error2 || "Something went wrong...!"
				};
			} else if (error.response.status == 404) {
				if (
					(
						(error.response &&
							error.response.config &&
							error.response.config.url) ||
						""
					).indexOf("graph") === -1
				) {
					error.response.data = {
						message: "The object referenced by the path does not exist."
					};
				} else {
					error.response.data = {
						message: ""
					};
				}
			}
		}
		errorHandler(error.response.data, error.response.status);
		return Promise.reject(error.response);
	}
);

/**
 * Api request Async to get data depends upon URL & params.
 * @param {*} param0
 * @returns
 */
export function apiRequestAsync({ url, params }) {
	store.dispatch({
		type: loaderActionType.SET_VISIBILITY,
		payload: false
	});
	const headers = getHeaders();
	headers.async = true;
	return axios
		.get(url, {
			headers,
			...{ params }
		})
		.then(responses => {
			return responses.data;
		})
		.catch(() => {
			// react on errors.
			//errorHandler(response);
			return {};
		});
}

/**
 * Api Post Async to send data depends upon URL & params.
 * @param {*} param0
 * @returns
 */
export function apiPostAsync({ url, postBody, params }) {
	const headers = getHeaders();
	headers.async = true;
	return axios
		.post(url, postBody, {
			headers,
			...{ params }
		})
		.then(({ data }) => {
			return { data, success: data.success };
		})
		.catch(() => {
			return { success: statusHandler(400), data: {} };
		});
}

/**
 * Api request to get data depends upon URL & params.
 * @param {*} param0
 * @returns
 */
export function apiRequest({ url, params, overrideHeaders }) {
	const headers =
		overrideHeaders !== undefined ? overrideHeaders : getHeaders();
	return axios
		.get(url, {
			headers,
			...{ params }
		})
		.then(responses => {
			return responses.data;
		})
		.catch(() => {
			return {};
		});
}

/**
 * get and response to multiple api call requests
 * @param {*} apiList - api list
 * @returns
 */
export function apiBatchRequest(apiList) {
	const apiAxiosArr = [];
	const headers = getHeaders();
	apiList.forEach(({ url, params }) => {
		apiAxiosArr.push(
			axios.get(url, {
				headers,
				...{ params }
			})
		);
	});

	const response = genericAPI(apiAxiosArr, apiList);

	return response;
}

/**
 * Batch Request with Cache Capability
 * @param {*} apiList
 * @returns
 */
export async function apiBatchRequestWithCache(apiList) {
	const apiAxiosArr = [];
	const headers = getHeaders();
	const cachedResponse = {};
	const cachedRequest = [];
	const nonCachedRequest = [];
	const cachedRequestKey = [];
	apiList.forEach(({ url, params, key, fromCache = false, duration = 10 }) => {
		if (fromCache === false) {
			apiAxiosArr.push(
				axios.get(url, {
					headers,
					...{ params }
				})
			);
			nonCachedRequest.push({ key: key });
		} else {
			cachedRequest.push(getDataFromStore(url, params, headers, duration));
			cachedRequestKey.push(key);
		}
	});

	const response = genericAPI(apiAxiosArr, nonCachedRequest);
	const arrayResponse = await Promise.all(cachedRequest);
	arrayResponse.forEach((x, i) => {
		cachedResponse[cachedRequestKey[i]] = x;
	});
	const result = await response;
	return { ...result, ...cachedResponse };
}

/**
 * Method for Getting Data From Store
 * @param {*} url
 * @param {*} params
 * @param {*} headers
 * @param {*} duration
 * @returns
 */
async function getDataFromStore(url, params, headers, duration = 1) {
	return new Promise(function(resolve) {
		const key = url + JSON.stringify(params);
		if (
			currentlyExecuting.find(x => x.key === key) === undefined &&
			getCachedData(key) === undefined
		) {
			currentlyExecuting.push({ key: key });
			axios
				.get(url, {
					headers,
					...{ params }
				})
				.then(responses => {
					localStore.push({ key: key, data: responses.data });
					store.dispatch({
						type: LocalCacheActionType.SET_CACHE_DATA,
						payload: { key: key, data: responses.data }
					});

					setTimeout(data => {
						data &&
							store.dispatch({
								type: LocalCacheActionType.CLEAR_CACHE_DATA_BY_KEY,
								payload: data.key
							});
					}, duration * 60 * 1000);

					currentlyExecuting = currentlyExecuting.filter(x => x.key !== key);
					return resolve(_.cloneDeep(responses.data));
				});
		} else {
			return resolve(waitFor(getCachedData, key));
		}
	});
}

/**
 * Wait Till Data received
 * @param {*} f
 * @param {*} key
 * @returns
 */
async function waitFor(f, key) {
	let r = f(key);
	while (!r) {
		// console.log('Not yet, waiting more');
		await delay(500);
		r = f(key);
	}
	return _.cloneDeep(r.data);
}

function delay(delay) {
	return new Promise(resolve => setTimeout(resolve, delay));
}

/**
 * Method for Getting Data from Cache
 * @param {*} key
 * @returns
 */
function getCachedData(key) {
	return (((store.getState() || {}).localCache || {}).cachedData || []).find(
		x => x.key === key
	);
}

/**
 * generic api call for multiple api
 * @param {*} apiAxiosArr
 * @param {*} apiList
 * @returns
 */
function genericAPI(apiAxiosArr, apiList) {
	const responseData = {};
	return axios
		.all(apiAxiosArr)
		.then(
			axios.spread((...responses) => {
				responses.forEach((res, i) => {
					responseData[apiList[i].key] = res.data;
				});

				return responseData;
			})
		)
		.catch(({ response }) => {
			//errorHandler(response);
			localStorage.setItem("isApiCalled","false");
			return response;
		});
}

/**
 * Api Put method to update data depends upon URL & params.
 * @param {*} param0
 * @returns
 */
export function apiPut({ url, postBody, params }) {
	const headers = getHeaders();
	return axios
		.put(url, postBody, {
			headers,
			...{ params }
		})
		.then(({ data, status }) => {
			return { data, success: statusHandler(status) };
		})
		.catch(() => {
			return { success: statusHandler(400), data: {} };
		});
}

/**
 * Api Put Async method to update data depends upon URL & params.
 * @param {*} param0
 * @returns
 */
export function apiPutAsync({ url, postBody, params }) {
	store.dispatch({
		type: loaderActionType.SET_VISIBILITY,
		payload: false
	});
	const headers = getHeaders();
	headers.async = true;
	return axios
		.put(url, postBody, {
			headers,
			...{ params }
		})
		.then(({ data, status }) => {
			return { data, success: statusHandler(status) };
		})
		.catch(() => {
			// react on errors.

			return { success: statusHandler(400), data: {} };
		});
}

/**
 * Api delete Async method to remove data depends upon URL & params.
 * @param {*} param0
 * @returns
 */
export function apiDeleteAsync({ url, params }) {
	store.dispatch({
		type: loaderActionType.SET_VISIBILITY,
		payload: false
	});
	const headers = getHeaders();
	headers.async = true;
	return axios
		.delete(url, {
			headers,
			...{ params }
		})
		.then(({ data, status }) => {
			return { data, success: statusHandler(status) };
		})
		.catch(() => {
			// react on errors.

			return { success: statusHandler(400), data: {} };
		});
}

/**
 * Api request or method to save or post data based upon URL and conditions
 * @param {*} param0
 * @returns
 */
export function apiPost({ url, postBody, params, overrideHeaders }) {
	const headers =
		overrideHeaders !== undefined ? overrideHeaders : getHeaders();

	return axios
		.post(url, postBody, {
			headers,
			...{ params }
		})
		.then(({ data }) => {
			return { data, success: data.success };
		})
		.catch(() => {
			// react on errors.

			return { success: statusHandler(400), data: {} };
		});
}

/**
 * Api delete method to remove data depends upon URL & params.
 * @param {*} url
 * @param {*} includeResponse
 * @returns
 */
export function apiDelete(url, includeResponse = false) {
	const headers = getHeaders();
	return axios
		.delete(url.url, {
			headers
		})
		.then(response => {
			if (includeResponse === true) {
				return response;
			}
			return response.data;
		});
}

/**
 * error handler
 * @param {*} response
 * @param {*} code
 * @returns
 */
function errorHandler(response, code) {
	if (!response) return;
	const errorMsg1 = response.message ? response.message : "";
	const errorMsg2 =
		response.error && response.error.message ? response.error.message : "";

	ShowToast(errorMsg1 || errorMsg2, toastType.ERROR, 5000, code);
}

/**
 * status handler
 * @param {*} status
 * @returns
 */
function statusHandler(status) {
	if (!status) return;
	switch (status) {
		case 200:
			return true;

		default:
			return false;
	}
}

/**
 * share point api request depends upon URL
 * @param {*} url
 * @returns
 */
export function getSpsAPiRequest(url) {
	const spsHeaders = {
		authorization: `${API_HEADERS.authName} ${SPSToken}`,
		"Cache-Control": "no-cache"
	};
	return axios
		.get(url, {
			headers: spsHeaders
		})
		.then(responses => {
			return responses.data;
		})
		.catch(data => {
			return data;
		});
}

/**
 * Share point API post
 * @param {*} param0
 * @returns
 */
export function spsApiPost({ url, postBody, params }) {
	const spsHeaders = {
		authorization: `${API_HEADERS.authName} ${SPSToken}`,
		"Cache-Control": "no-cache"
	};
	return axios
		.post(url, postBody, {
			headers: spsHeaders,
			...{ params }
		})
		.then(({ data, status }) => {
			return { data, success: statusHandler(status) };
		})
		.catch(() => {
			return { success: statusHandler(400), data: {} };
		});
}

/**
 * Share point API request for upload file
 * @param {*} url
 * @param {*} file
 * @param {*} isAddContent
 * @returns
 */
export function uploadSpsAPiRequest(url, file, isAddContent = false) {
	const spsHeaders = {
		authorization: `${API_HEADERS.authName} ${SPSToken}`,
		...(isAddContent && {
			"Content-Length": file.size,
			"Content-Range": `bytes 0-${file.size - 1}/${file.size}`
		}),
		"Cache-Control": "no-cache"
	};
	return axios
		.put(url, file, {
			headers: spsHeaders
		})
		.then(responses => {
			return responses.data;
		})
		.catch(({ response }) => {
			return response;
		});
}

/**
 * Share point metadata upload request
 * @param {*} url
 * @param {*} metadata
 * @returns
 */
export function uploadSpsMetadataAPiRequest(url, metadata) {
	const spsHeaders = {
		authorization: `${API_HEADERS.authName} ${SPSToken}`,
		"Cache-Control": "no-cache"
	};
	return axios
		.patch(url, metadata, {
			headers: spsHeaders
		})
		.then(responses => {
			this.props.getSpsData();
			return responses.data;
		})
		.catch(({ response }) => {
			return response;
		});
}

/**
 * share point api delete request
 * @param {*} url
 * @returns
 */
export function deleteSpsApiRequest(url) {
	const spsHeaders = {
		authorization: `${API_HEADERS.authName} ${SPSToken}`,
		"Cache-Control": "no-cache"
	};
	return axios
		.delete(url, {
			headers: spsHeaders
		})
		.then(() => {
			//this.props.getSpsData();
			return true;
		})
		.catch(() => {
			//console.log(error, "Delete API");
			return true;
		});
}
